import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCrossinline = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.47 4.47l15.012 15.012m0-15.012L4.471 19.483",
		fill: "none",
		strokeLinecap: "square",
		strokeLinejoin: "round",
		stroke: "currentColor",
		strokeWidth: 2
	})
});
export default SvgCrossinline;
